export enum STARGATE_ROUTES {
  INDEX = '/',
  RESALE_INTENTION = '/intencao-de-revenda',
  EXTENDED_CAPTATION = '/ciclo-estendido',
  CONTENT_API = '/api/content',
  ERROR_500 = '/500',
  ERROR_401 = '/401',
  ERROR_403 = '/403',
  ERROR_GENERIC = '/error-generic',
  ERROR_VDF = '/revendedores-grupoboticario',
  ERROR_PROCESS = '/process-error',
  ERROR_COMBO = '/combo-error',
  LOGIN = '/login',
  FAQ = '/perguntas-frequentes',
  LOGOUT = '/logout',
  GIFTS = '/checkout/brindes',
  PRODUCTS_BY_TAG = '/vitrines',
  EMPTY_RECOMMENDATION = '/recomendacao-indisponivel',
  TAPUME = '/indisponivel',
  CATEGORIES = '/categorias',
  COMBO = '/combo',
  CHECKOUT = '/checkout',
  CHECKOUT_CONFIRMATION = '/confirmation/:orderCode',
  DEPARTMENT = '/departamentos/:department',
  SEARCH = '/pesquisa',
  PRODUCT_DETAIL = '/produto/:slugName',
  RECOVER_PASSWORD = '/recuperacao-de-senha',
  RECOVER_PASSWORD_EMAIL = '/recuperacao-de-senha/email',
  RECOVER_PASSWORD_EMAIL_SUCCESS = '/recuperacao-de-senha/email/sucesso',
  CART = '/carrinho',
}

export enum MF_SELF_SERVICE_ROUTES {
  RESELLER_SPACE = '/espaco-do-revendedor',
  REPRESENTANT_SPACE = '/espaco-do-representante',
  CYCLES_CATALOG = '/catalogos-dos-ciclos',
  CYCLES_CATALOG_ACTUAL = '/catalogos-dos-ciclos/ciclo-atual',
  CYCLES_CATALOG_NEXT = '/catalogos-dos-ciclos/proximo-ciclo',
  DIGITAL_GUIDE = '/guia-digital',
  DIVULGATION_IMAGES = '/imagens-de-divulgacao',
  DIVULGATION_IMAGES_CONTENT = '/imagens-de-divulgacao/:content',
  IMPORTANT_WARNINGS = '/avisos-importantes',
  IMPORTANT_WARNINGS_CONTENT = '/avisos-importantes/:content',
  CYCLE_HIGHLIGHTS = '/destaques-do-ciclo',
  CYCLE_HIGHLIGHTS_CONTENT = '/destaques-do-ciclo/:content',
  TIPS_AND_TRAINING = '/dicas-e-treinamentos',
  TIPS_AND_TRAINING_CONTENT = '/dicas-e-treinamentos/:content',
  RESELLER_MAGAZINE = '/revista-do-revendedor',
  RESELLER_MAGAZINE_CONTENT = '/revista-do-revendedor/:content',
  PLUS_GUIDE = '/guia-mais',
  PLUS_GUIDE_CONTENT = '/guia-mais/:content',
  ORDERS = '/pedidos',
  ORDER = '/pedido/:code',
  CATALOG_CONFIG = '/configurar-catalogo',
  PROFILE = '/perfil',
  PROFILE_EDIT_CELLPHONE_PASSWORD = '/perfil/editar/celular/senha',
  PROFILE_EDIT_CELLPHONE_CONFIRMATION = '/perfil/editar/celular/confirmacao',
  PROFILE_EDIT_CELLPHONE_SUCCESS = '/perfil/editar/celular/sucesso',
  PROFILE_EDIT_CELLPHONE_ERROR = '/perfil/editar/celular/erro',
  PROFILE_EDIT_ADDRESS_PASSWORD = '/perfil/editar/endereco/senha',
  PROFILE_EDIT_ADDRESS_IMPORTANT_INFORMATION = '/perfil/editar/endereco/informacoes-importantes',
  PROFILE_EDIT_ADDRESS_CONFIRMATION = '/perfil/editar/endereco/confirmacao',
  PROFILE_EDIT_ADDRESS_MODAL_CONFIRMATION = '/perfil/editar/endereco/modal-confirmacao',
  PROFILE_EDIT_ADDRESS_SUCCESS = '/perfil/editar/endereco/sucesso',
  PROFILE_EDIT_ADDRESS_ERROR = '/perfil/editar/endereco/erro',
  PROFILE_EDIT_EMAIL_PASSWORD = '/perfil/editar/email/senha',
  PROFILE_EDIT_EMAIL_CONFIRMATION = '/perfil/editar/email/confirmacao',
  PROFILE_EDIT_EMAIL_SUCCESS = '/perfil/editar/email/sucesso',
  PROFILE_EDIT_EMAIL_ERROR = '/perfil/editar/email/erro',
  INCENTIVES_CAMPAIGN = '/campanha-de-incentivos/:content',
  INCENTIVES_CAMPAIGN_RESULT = '/campanha-de-incentivos/:content/resultado',
  MATERIALS = '/materiais/:title',
}

export const salesManagementRoutes = [
  'minhas-vendas',
  'adicionar',
  'compartilhar/:id',
  'cobrar/:id',
  'editar-produtos',
  'organizar-vendas',
  'select-products',
  'selecionar-cliente',
  'clientes-adicionados-sucesso',
  'alterar-parcelas',
  'aprovar-venda:id',
  'vendas-recebidas',
  'minhas-vendas-sellin',
  'detalhe-parcela',
  'criar-recebivel',
  'editar-produtos',
  'inserir-valor-cobranca',
  'selecionar-forma-de-pagamento',
  'concluir-cobranca',
  ':id',
];
